import { useTranslation } from 'react-i18next'
import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import Button from '@carsys/ui/src/Button'
import { IShopWholesaler } from '@cbgms/api'
import { SelectWholesaler } from 'app/accounts/components/SetupWholesalers/SelectWholesaler'
import { Loader } from '@carsys/ui/src/Loader'

interface Props {
  setSelectedWholesaler: (w: IShopWholesaler) => void
  handleClose: () => void
  wholesalers?: IShopWholesaler[]
  isLoading: boolean
  cancelWholesalerSelectButtonSlot?: React.ReactNode
}

export function SelectWholesalerDialogContent({
  setSelectedWholesaler,
  handleClose,
  wholesalers,
  isLoading,
  cancelWholesalerSelectButtonSlot
}: Props) {
  const { t } = useTranslation()

  if (isLoading || !wholesalers) {
    return (
      <DialogContent>
        <Loader loading data-testid='loader' />
      </DialogContent>
    )
  }

  return (
    <>
      <DialogTitle>{t('account.supplier_select')}</DialogTitle>
      <DialogContent>
        <SelectWholesaler onSelect={setSelectedWholesaler} wholesalers={wholesalers} hideSearch={false} />
      </DialogContent>
      <DialogActions>
        {cancelWholesalerSelectButtonSlot || (
          <Stack direction='row' spacing={1}>
            <Button variant='text' onClick={handleClose}>
              {t('global.cancel')}
            </Button>
          </Stack>
        )}
      </DialogActions>
    </>
  )
}
